/**
 * Hmotnost dílu pro zákazníka.
 *
 * KAN-1036: karta s cenou i souhrn košíku tiskly ``kg.toFixed(2)``, což
 * u 3D tisku znamená, že se **skoro každý díl zobrazí špatně** — vrácených
 * ``0.008 kg`` je „0.01 kg" (o čtvrtinu víc) a cokoli pod 5 gramy je
 * „0.00 kg", tedy nic. Pod kilo se proto přepíná na gramy, stejně jako to
 * dělá uhlíková stopa (``CarbonBadge``, ``CarbonSummaryCard``).
 *
 * Jednotka se nepřekládá — ``kg`` a ``g`` jsou SI značky, ne slova.
 */
export function formatWeightKg(kg: number, locale?: string): string {
  if (!Number.isFinite(kg)) return "—";
  if (Math.abs(kg) < 1) {
    const grams = kg * 1000;
    // Desetina gramu je mez, pod kterou už údaj nikomu nepomůže; nad
    // deset gramů je i ta zbytečná přesnost („17 g", ne „17,2 g").
    const digits = Math.abs(grams) < 10 ? 1 : 0;
    return `${grams.toLocaleString(locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: digits,
    })} g`;
  }
  return `${kg.toLocaleString(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} kg`;
}

/**
 * KAN-1903 — a kilogram AMOUNT for a sentence that already carries the unit
 * ("Celková hmotnost {{weight_kg}} kg …"): locale-grouped, at most one
 * decimal. The cart printed the engine's raw float — „2357.1195 kg".
 * Non-numbers come back as-is so a missing param does not become „NaN".
 */
export function formatKgAmount(kg: unknown, locale?: string): string {
  const n = typeof kg === "number" ? kg : Number(kg);
  if (kg === null || kg === undefined || kg === "" || !Number.isFinite(n)) {
    return kg === null || kg === undefined ? "" : String(kg);
  }
  return n.toLocaleString(locale, { minimumFractionDigits: 0, maximumFractionDigits: 1 });
}

/** KAN-1903 — a whole count (pieces, items) locale-grouped: „1 500", not „1500". */
export function formatCount(value: unknown, locale?: string): string {
  const n = typeof value === "number" ? value : Number(value);
  if (value === null || value === undefined || value === "" || !Number.isFinite(n)) {
    return value === null || value === undefined ? "" : String(value);
  }
  return n.toLocaleString(locale, { maximumFractionDigits: 0 });
}
